import { AVAILABILITY_UPDATED } from './actionTypes'

const INITIAL_STATE = {
  updated: false,
}

export const PractitionerAvailabilityCalendarReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case AVAILABILITY_UPDATED:
      return {
        ...state,
        updated: action.value,
      }

    default:
      return state
  }
}
